'use client';

import { useEffect, useState } from 'react';
import { getUA } from 'react-device-detect';

export const IsPWA = () => {
  const [isPwa, setIsPwa] = useState(false);
  const userAgent = getUA;

  useEffect(() => {
    setIsPwa(userAgent.includes('PWAShell'));
  }, [userAgent]);

  return isPwa;
};
